import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { SecretsStore } from './SecretsStore';
import { WebSecretsStore } from './WebSecretsStore';
import { NucleusTokenInterceptor } from './NucleusTokenInterceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NucleusIdentityConfig } from './NucleusIdentityConfig';

@NgModule({
  imports: [
  ],
  declarations: [
  ],
  exports: [
  ]
})
  
export class NucleusIdentityModule {

  static forRoot(config: NucleusIdentityConfig, secretsStoreClass = WebSecretsStore): ModuleWithProviders {

    return {
      ngModule: NucleusIdentityModule,
      providers: [
        { provide: SecretsStore, useClass: secretsStoreClass },
        { provide: NucleusIdentityConfig, useValue: config },
        { provide: HTTP_INTERCEPTORS, useClass: NucleusTokenInterceptor, multi: true }
      ]
    };
  }
}
